import {TransportTypeEnum} from "@models/enums/transport-type.enum";

export class ToolTransport {

    public id: number;
    public name: string;
    public location: string;
    public destination: string;
    public status: string;
    public hasPriority: boolean;
    public priorityReason: string;
    public plantName: string;
    public createdDate: string;
    public reason: string;
    public createdBy: string;
    public transportType: TransportTypeEnum;
    public toolMaxTransportTime: number;

    constructor(toolTransport: any = {}) {
        this.id = toolTransport.id || 0;
        this.name = toolTransport.name || '';
        this.location = toolTransport.location || '';
        this.destination = toolTransport.destination || '';
        this.status = toolTransport.status || '';
        this.hasPriority = toolTransport.hasPriority || false;
        this.priorityReason = toolTransport.priorityReason || '';
        this.plantName = toolTransport.plantName || '';
        this.createdDate = toolTransport.createdDate || '';
        this.reason = toolTransport.reason || '';
        this.createdBy = toolTransport.createdByName || '';
        this.transportType = toolTransport.type || TransportTypeEnum.LINE;
        this.toolMaxTransportTime = toolTransport.toolMaxTransportTime ?? null;
    }

    get type() {
        return 'tool-transport';
    }
}
